import { gql } from '@apollo/client';
import IconDocument from '@apollo/icons/default/IconDocument.svg';
import IconSandbox from '@apollo/icons/default/IconSandbox.svg';
import IconSingleService from '@apollo/icons/default/IconSingleService.svg';
import IconTime from '@apollo/icons/default/IconTime.svg';
import { Button } from '@apollo/orbit';
import React, { useState } from 'react';

import {
  LocalTimestamp,
  coerceToMoment,
} from 'src/components/timestamp/Timestamp';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { isMinLengthArray } from 'src/lib/isMinLengthArray';

export const ChecksTableWorkflowCellWorkflowFragment = gql`
  fragment ChecksTableWorkflowCellWorkflowFragment on CheckWorkflow {
    id
    subgraphNames
    createdAt
    isSandboxCheck
    tasks {
      id
    }
  }
`;

export const ChecksTableWorkflowCell = ({
  workflow,
}: {
  workflow: GraphQLTypes.ChecksTableWorkflowCellWorkflowFragment;
}) => {
  const mutableDate = coerceToMoment(workflow.createdAt);
  const [showAllSubgraphs, setShowAllSubgraphs] = useState(false);

  return (
    <div className="flex flex-col gap-2 truncate text-base">
      {isMinLengthArray(1, workflow.subgraphNames) &&
        (showAllSubgraphs
          ? workflow.subgraphNames
          : [workflow.subgraphNames[0]]
        ).map((subgraphName, index) => (
          <div className="flex items-center" key={subgraphName}>
            <IconSingleService className="text-icon-primary" />
            <span className="ml-2 truncate">
              {subgraphName}
              {(!showAllSubgraphs || index === 0) &&
                isMinLengthArray(2, workflow.subgraphNames) && (
                  <span className="ml-2 font-semibold">
                    +{workflow.subgraphNames.length - 1}
                  </span>
                )}
            </span>
            {isMinLengthArray(2, workflow.subgraphNames) && index === 0 && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAllSubgraphs((prev) => !prev);
                }}
                size="xs"
                className="ml-2 shrink-0"
                variant="secondary"
              >
                Show {showAllSubgraphs ? 'less' : 'all'}
              </Button>
            )}
          </div>
        ))}
      {workflow.tasks.findIndex(
        (task) => task.__typename === 'FilterCheckTask',
      ) > -1 && (
        <div className="flex items-center">
          {/* TODO: once we decide on an icon, put it here */}
          <IconDocument className="text-icon-primary" />
          <span className="ml-2">Contract check</span>
        </div>
      )}
      {workflow.isSandboxCheck && (
        <div className="flex items-center">
          <IconSandbox className="text-icon-primary" />
          <span className="ml-2">Sandbox check</span>
        </div>
      )}
      <div className="flex items-center">
        <IconTime className="text-icon-primary" />
        <span className="ml-2 mr-1 truncate text-secondary">
          Initiated{' '}
          <LocalTimestamp className="truncate" value={mutableDate}>
            <span className="font-semibold text-secondary">
              {mutableDate.fromNow()}
            </span>
          </LocalTimestamp>
        </span>
      </div>
    </div>
  );
};
